import React from 'react';
import { Container, Grid, Box } from '@mui/material';
import LandingPageNav from '../../components/landingpage/LandingPageNav';
import QuickAccessCards from './QuickAccessCards';
import BannerImageHomePage from './bannerImageHomePage';
import Footer from '../../components/Footer/footer';
import Carousel from '../../components/blog/blogCarousel';
import PeopleTabsSection from '../../components/impactSection/impactTabs';

export default function HomePage() {
  return (
    <>
      <LandingPageNav />

      {/* Spacer so content sits below fixed AppBar (handles 56px mobile / 64px desktop automatically) */}
      <Box sx={{ height: { xs: 56, sm: 64 } }} />

      <BannerImageHomePage />
      {/* Optional: a little extra breathing room */}
      <Container maxWidth="xxl" sx={{ pt: { xs: 1, sm: 2 } }}>
        <Grid container spacing={4} direction="column">
          {/* Make the banner full width */}
          

          <Grid item xs={12}>
            <QuickAccessCards />
          </Grid>

          <Grid item xs={12}>
            <PeopleTabsSection videoId="YOUR_YOUTUBE_ID" />
          </Grid>

          <Grid item xs={12}>
            <Carousel />
          </Grid>

          
        </Grid>
      </Container>
      <Box sx={(theme) => ({ ...theme.mixins.toolbar })} />
      <Footer />
    </>
  );
}
